import FormJaivana from 'dashboard_jaivana_v1';



class CustomDuplicarFormula extends FormJaivana.form {
    constructor(props) {
        super(props);
        this.initForm = this.initForm.bind(this);
        this.consultarFormula = this.consultarFormula.bind(this);
        this.successTraerComponentes = this.successTraerComponentes.bind(this);
        this.duplicarFormula = this.duplicarFormula.bind(this);
        this.successDuplicar = this.successDuplicar.bind(this);
        this.limpiarCampos = this.limpiarCampos.bind(this);
    }

    initForm() {
        console.log('Duplicar Formula @version: 1.01.0034, @author: Cristian Ciro');

        this.getField('btn_consultar').setClick(this.consultarFormula);
        this.getField('btn_duplicar').setClick(this.duplicarFormula);
        this.getField('producto').setOnChange(this.limpiarCampos);
    }
    limpiarCampos() {
        let codProd = this.getField('producto').getValue();
        if (codProd !== '' && codProd !== ' ' && codProd !== undefined) {
            this.getField('tb_componentes').toggle(false);
            this.getField('produccionformulasversionesnuevo_id').setVisible(false);
            this.getField('btn_duplicar').setVisible(false);
            this.getField('produccionformulasversionesnuevo_id').setError(false,'');
            this.getField('nombre').setError(false,'');
            this.getField('produccionformulasversiones_id').setValue('');
            this.getField('nombre').setValue('');
            //this.getField('articulo_id').setValue('');
        }
    }

    consultarFormula() {
        let artId = this.getField('articulo_id').getValue();
        let versionid = this.getField('produccionformulasversiones_id').getValue();
        if (artId !== '' && artId !== null && artId !== undefined) {
            this.getField('nombre').setError(false,'');
            if(versionid !== '' && versionid !== null && versionid !== undefined){
                this.uploadTable();
            }else {
                this.getField('nombre').setError(true,'* Este campo es requerido');

            }
        } else {

            this.getField('nombre').setError(true,'* Este campo es requerido');
        }

    }

    successTraerComponentes(data) {
        if (data.estado_p === 200) {
            this.getField('btn_duplicar').setVisible(true);
            this.getField('produccionformulasversionesnuevo_id').setVisible(true);
            //console.log('data', data);

            this.gridOptions['rowData'] = data.data;
            this.getField('tb_componentes').initData(this.gridOptions);
            //this.gridOptions.api.sizeColumnsToFit();
            const allColumnIds = [];
            this.gridOptions.columnApi.getAllColumns().forEach((column) => {
                allColumnIds.push(column.getId());
            });
            this.gridOptions.columnApi.autoSizeColumns(allColumnIds, false);

        } else {
            this.getField('tb_componentes').toggle(false);
        }
    }

    duplicarFormula() {            
        this.getField('produccionformulasversionesnuevo_id').setError(false,'');

        let formNueva = this.getField('produccionformulasversionesnuevo_id').getValue();
        if (formNueva !== '' && formNueva !== null && formNueva !== undefined) {
            let datos = {
                datos:{
                    articulo_id: this.getField('articulo_id').getValue(),    // body : es un objeto que contiene los parámetros que se necesitan para realizar la peticion
                    produccionformulasversiones_id: this.getField('produccionformulasversiones_id').getValue(),
                    produccionformulasversionesnuevo_id: parseInt(this.getField('produccionformulasversionesnuevo_id').getValue()),
                }
            }
            //console.log('body a enviar', body);
            this.generalFormatPmv = { tipo_servicio: 'prod-formulaciones', operacion: 'duplicar', operacion_tipo: 'crear' };
            this.service.send({
                endpoint: this.constant.formConfiguration(),
                method: 'POST',
                body: datos,
                success: this.successDuplicar,
                error: this.error_,
                general: this.generalFormatPmv
            });
            /*this.generalFormat.nombre_accion = '1287-servicio_produccion_formulaciones_duplicar'; // nombre_accion : es el nombre que tenga el servicio en la tabla servicios_formulario
            this.service.send(
                {
                    endpoint: this.constant.formConfiguration(),
                    method: 'POST',
                    body: body,
                    success: this.successDuplicar,
                    error: this.error_,
                    general: this.generalFormat
                });*/
        } else {
            this.getField('produccionformulasversionesnuevo_id').setError(true,'* Este campo es requerido');
        }
    }

    successDuplicar(data) {
        if (data.estado_p === 200) {
            //console.log('data', data);
            //this.uploadTable();
            this.limpiarCampos();
        }
    }

    uploadTable() {
        let artId = this.getField('articulo_id').getValue();
        let versionid = this.getField('produccionformulasversiones_id').getValue();
        if (artId !== '' && artId !== null && artId !== undefined && versionid !== '' && versionid !== null && versionid !== undefined) {

            let datos = {
                datos:{
                    value: this.getField('articulo_id').getValue()+"",    // body : es un objeto que contiene los parámetros que se necesitan para realizar la peticion
                    produccionformulasversiones_id: this.getField('produccionformulasversiones_id').getValue(),
                }
            }
            //console.log('body a enviar', body);
            // prod-formulasprodcomponentes-articuloid

            this.generalFormatPmv = { tipo_servicio: 'prod-formulasprodcomponentes', operacion: 'articuloid', operacion_tipo: 'consulta' };
            this.service.send({
                endpoint: this.constant.formConfiguration(),
                method: 'GET',
                body: datos,
                success: this.successTraerComponentes,
                error: this.error_,
                general: this.generalFormatPmv
            });
            /*this.generalFormat.nombre_accion = '1287-servicio_traer_componentes_formula_por_articuloid'; // nombre_accion : es el nombre que tenga el servicio en la tabla servicios_formulario
            this.service.send(
                {
                    endpoint: this.constant.formConfiguration(),
                    method: 'GET',
                    body: body,
                    success: this.successTraerComponentes,
                    error: this.error_,
                    general: this.generalFormat
                });*/
        }
        this.getField('produccionformulasversionesnuevo_id').setValue('');
    }
}

FormJaivana.addController("prod-duplicarformula", CustomDuplicarFormula);

export default CustomDuplicarFormula;

